import { Layout } from 'antd'
import jwtDecode from 'jwt-decode'
import { useEffect } from 'react'
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom'
import styled from 'styled-components'
import CySider from '../components/CySider/CySider'
import { GET_API_TOKEN } from '../constants/apiConstants'
import * as PathConstants from '../constants/pathConstant'
import AlertsView from '../containers/AlertsView/AlertsView'
import DashboardView from '../containers/DashboardView/DashboardView'
import DoctorsView from '../containers/DoctorsView/DoctorsView'
import LoginScreen from '../containers/LoginScreen/LoginScreen'
import NursesView from '../containers/NursesView/NursesView'
import PatientsView from '../containers/PatientsView/PatientsView'

const { Content } = Layout
const MainStyledLayout = styled(Content)`
  min-height: calc(100vh - 65px);
  display: flex;
  flex-direction: column;
`

function AppRoute() {
  return (
    <Router basename={PathConstants.APP_PATH}>
      <Routes>
        <Route
          path={PathConstants.ROOT_PATH}
          element={<InnerPageContainer children={<></>} />}
        />
        <Route
          path={PathConstants.DASHBOARD}
          element={<InnerPageContainer children={<DashboardView />} />}
        />
        <Route
          path={PathConstants.PATIENTS}
          element={<InnerPageContainer children={<PatientsView />} />}
        />
        <Route path={PathConstants.LOGIN_PATH} element={<LoginScreen />} />
        <Route
          path={PathConstants.DOCTORS}
          element={<InnerPageContainer children={<DoctorsView />} />}
        />
        <Route
          path={PathConstants.NURSES}
          element={<InnerPageContainer children={<NursesView />} />}
        />
        <Route
          path={PathConstants.ALERTS}
          element={<InnerPageContainer children={<AlertsView />} />}
        />
      </Routes>
    </Router>
  )
}

function TokenValidationContainer({ children }: { children: JSX.Element }) {
  const navigate = useNavigate()
  const location = useLocation()

  const getTokenValidState = () => {
    let token = GET_API_TOKEN()
    try {
      let decoded: any = jwtDecode(token!)
      if (Date.now() >= decoded.exp * 1000) {
        return false
      } else {
        return true
      }
    } catch (error) {
      return false
    }
  }
  const isTokenValidState = getTokenValidState()
  const pathName = location.pathname

  useEffect(() => {
    if (!isTokenValidState) {
      navigate(PathConstants.LOGIN_PATH)
    }
    if (isTokenValidState && pathName === PathConstants.ROOT_PATH) {
      navigate(PathConstants.DASHBOARD)
    }
  }, [isTokenValidState])

  if (!isTokenValidState || pathName === PathConstants.ROOT_PATH) {
    return <></>
  }

  return <>{children}</>
}

function InnerPageContainer({ children }: { children: JSX.Element }) {
  return (
    <TokenValidationContainer>
      <Layout style={{ background: '#f3f3f3' }}>
        <CySider currentPath={useLocation().pathname} />
        <Layout style={{ background: '#f3f3f3' }}>
          <MainStyledLayout>{children}</MainStyledLayout>
        </Layout>
      </Layout>
    </TokenValidationContainer>
  )
}

export default AppRoute
